import { useMutation as useApolloMutation } from '@apollo/client'

export const useMutation = (query, options = { fetchPolicy: 'no-cache' }) => {
  const [getData, data] = useApolloMutation(query, options)

  const queryFn = options => getData(options)

  return [queryFn, data]
}
